// export const HOST = "https://yee78zfatm.us-east-1.awsapprunner.com";
//export const HOST = "https://api.staging.investwithaqua.com";
// run local server
//export const HOST = "http://127.0.0.1:8000";
export const HOST = process.env.REACT_APP_API_ENDPOINT;
